import $ from 'static/script/libs/jquery';

function isHybridAppWithMinBuild(minBuild) {
    let appData = document.getElementById('app-data');
    if (appData == null) {
        return false;
    }

    let data = JSON.parse(appData.value);
    let build = data['app-build'];
    return build >= minBuild;
}

export default isHybridAppWithMinBuild;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/is-hybrid-app-with-min-build.js